module.exports = Promise.resolve(module.bundle.root("1pD5p"))